// InstanceCard — paralelo ao ContainerCard, mas para uma instância EC2
// (alvo do DeployModal). Mesmo design system, ícone diferente.

import { Badge, Box, Group, Stack, Text } from '@mantine/core'
import { IconClock, IconServer } from '@tabler/icons-react'
import { COLOR, SURFACE } from './tokens'
import { formatElapsed, useTicker } from './useTicker'

interface Props {
  instanceName: string
  instanceId: string
  /** ISO/epoch ms timestamp; while present, replaces uptime with a live
   *  elapsed-time badge re-rendered every 1s. */
  operationStartedAt?: string | number
  uptime?: string
}

export function InstanceCard({
  instanceName,
  instanceId,
  operationStartedAt,
  uptime,
}: Props) {
  useTicker(operationStartedAt ? 1000 : 60_000)
  const elapsed = operationStartedAt
    ? formatElapsed(
        Date.now() -
          (typeof operationStartedAt === 'number'
            ? operationStartedAt
            : new Date(operationStartedAt).getTime()),
      )
    : null

  return (
    <Box
      p={12}
      style={{
        background: SURFACE.card,
        border: `1px solid ${SURFACE.cardBorder}`,
        borderRadius: 8,
        boxShadow: SURFACE.cardShadow,
      }}
    >
      <Group gap={12} align="center" wrap="nowrap">
        <Box
          style={{
            width: 36,
            height: 36,
            borderRadius: 8,
            background: COLOR.brandGradient,
            display: 'grid',
            placeItems: 'center',
            color: '#fff',
            flexShrink: 0,
          }}
          aria-hidden="true"
        >
          <IconServer size={20} />
        </Box>
        <Stack gap={2} style={{ minWidth: 0, flex: 1 }}>
          <Text
            fw={600}
            size="md"
            style={{
              fontFamily: '"Barlow", sans-serif',
              color: SURFACE.textPrimary,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {instanceName}
          </Text>
          <Text
            size="xs"
            style={{
              fontFamily: '"JetBrains Mono", monospace',
              color: SURFACE.textSecondary,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
            title={instanceId}
          >
            {instanceId}
          </Text>
        </Stack>
        {elapsed ? (
          <Badge
            variant="light"
            color="inovareTeal"
            size="sm"
            leftSection={<IconClock size={12} />}
            style={{ fontFamily: '"JetBrains Mono", monospace' }}
            aria-live="polite"
            title="Tempo decorrido"
          >
            {elapsed}
          </Badge>
        ) : uptime ? (
          <Badge variant="light" color="inovareTeal" size="sm">
            {uptime}
          </Badge>
        ) : null}
      </Group>
    </Box>
  )
}
